import * as yup from 'yup';

export const yupValidationProps = {
    Saque_Valor_Minimo: yup
        .number()
        .min(0, 'O valor mínimo do saque não pode ser negativo'),
    Saque_Retencao_Dias: yup
        .number()
        .min(0, 'A retenção não pode ser negativa'),
    Saque_Prazo_Padrao_Dias: yup
        .number()
        .min(0, 'O prazo padrão não pode ser negativo'),
    Saque_Taxa_Antecipacao_Valor: yup
        .number()
        .min(0, 'A taxa de antecipação não pode ser negativa')
        .when('Saque_Taxa_Antecipacao_Tipo', {
            is: 'percentual',
            then: yup
                .number()
                .max(100, 'A taxa percentual não pode passar de 100%'),
        }),
    Saque_Data_Corte: yup
        .string()
        .matches(/^\d{4}-\d{2}-\d{2}$/, {
            message: 'Use o formato AAAA-MM-DD',
            excludeEmptyString: true,
        }),
};
